import React from "react";
import { useT } from "@/i18n";

export function LangToggle({ className = "" }) {
  const { lang, setLang } = useT();
  return (
    <div
      data-testid="lang-toggle"
      className={`inline-flex items-center rounded-full border border-slate-700 bg-slate-900/60 p-0.5 text-xs font-medium ${className}`}
    >
      <button
        type="button"
        onClick={() => setLang("ro")}
        data-testid="lang-ro"
        className={`px-2.5 py-1 rounded-full transition-colors ${lang === "ro" ? "bg-primary text-white" : "text-slate-400 hover:text-white"}`}
      >
        RO
      </button>
      <button
        type="button"
        onClick={() => setLang("en")}
        data-testid="lang-en"
        className={`px-2.5 py-1 rounded-full transition-colors ${lang === "en" ? "bg-primary text-white" : "text-slate-400 hover:text-white"}`}
      >
        EN
      </button>
    </div>
  );
}
